import timeGridPlugin from "@fullcalendar/timegrid";
import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getCalender } from "../../../../redux/calender/action";
import ModelTaskDetails from "../ModelTaskDetails";
import ModalMilestoneDetails from "../ModalMilestoneDetails";
import CalendarModel from "../CalenderModel";
import ContestDetailModal from "../ContestDetailModal";
import { addOneDayToDate, formatDate } from "../../../../assests/extention/commonfunction";

export default function CalendarWeeks({ id, action }) {
  const [modal, setModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [date, setDate] = useState({
    start_date: "",
    end_date: "",
  });
  const [events, setEvents] = useState([]);

  const dispatch = useDispatch();
  const calendar = useSelector(
    ({ calender: { calenderdetails } }) => calenderdetails
  );

  const convertEventsToApiResponse = (holidays, milestones, task, contest) => {

    const formattedHolidays = holidays.map((event) => ({
      ...event,
      id: event?.id,
      model_id: event?.id,
      model_title: event?.title,
      title: event.title,
      start: formatDate(event?.start_date),
      end: addOneDayToDate(event?.end_date),
      color: "red",
      type: "Holiday",
      event_type: 1,
    }));

    const formattedMilestones = milestones.map((event) => ({
      ...event,
      id: event?.id,
      model_id: event?.id,
      model_title: event?.title,
      title: event.post_title,
      start: formatDate(event?.ends_on),
      end: formatDate(event?.ends_on),
      color: "#dfd2c7",
      type: "Milestone",
      event_type: 2,
    }));

    const formattedTasks = task.map((event) => {
      let startDateTime = formatDate(event?.due_date);
      let endDateTime = formatDate(event?.due_date);
      let isAllDay = true;

      if (event?.due_time) {
        startDateTime = `${startDateTime}T${event.due_time}`;

        // Add 1 hour to the start time for the end time so it shows up nicely in the grid
        const dateObj = new Date(startDateTime);
        dateObj.setHours(dateObj.getHours() + 1);

        // Ensure format YYYY-MM-DDTHH:mm:ss for consistency
        const pad = (n) => n < 10 ? '0' + n : n;
        endDateTime = `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())}T${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
        isAllDay = false;
      }

      return {
        ...event,
        id: event?.id,
        model_id: event?.id,
        model_title: event?.title,
        title: event.title,
        description: event.description,
        start: startDateTime,
        end: endDateTime,
        allDay: isAllDay,
        color: "#ef7710",
        type: "Task",
        event_type: 3,
      };
    });

    const formattedContests = contest.map((contest) => ({
      ...contest,
      id: contest?.id,
      model_id: contest?.id,
      model_title: contest?.title,
      title: contest.title,
      description: contest.description,
      start: formatDate(contest?.last_date),
      end: formatDate(contest?.last_date),
      color: "#cee1ff",
      type: "Contest",
      event_type: 4,
    }));

    return [
      ...formattedHolidays,
      ...formattedMilestones,
      ...formattedTasks,
      ...formattedContests,
    ];
  };

  useEffect(() => {
    if (date?.start_date && date?.end_date) {
      dispatch(getCalender(date?.start_date, date?.end_date, id));
    }
  }, [date?.start_date, date?.end_date, dispatch]);

  useEffect(() => {
    if (calendar?.task && calendar?.milestones && calendar?.holidays) {
      const apiResponse = convertEventsToApiResponse(
        calendar.holidays,
        calendar.milestones,
        calendar.task,
        calendar.contests
      );
      setEvents(apiResponse);
    }
  }, [calendar]);

  const toggle = () => setModal(!modal);

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
    toggle();
  };
  const handleDatesSet = (arg) => {
    const startDate = new Date(arg?.startStr).toISOString().split("T")[0];
    const endDate = new Date(arg?.endStr).toISOString().split("T")[0];
    setDate({
      start_date: startDate || "",
      end_date: endDate || "",
    });
  };

  const apihit = () => {
    dispatch(getCalender(date?.start_date, date?.end_date, id));
  }

  useEffect(() => {
    if (action && date?.start_date && date?.end_date) {
      dispatch(getCalender(date?.start_date, date?.end_date, id));
    }
  }, [action])

  return (
    <div>
      <FullCalendar
        plugins={[timeGridPlugin]}
        initialView="timeGridWeek"
        events={events}
        eventClick={handleEventClick}
        scrollTime="00:00:00"
        slotMinTime="00:00:00"
        slotMaxTime="24:00:00"
        datesSet={handleDatesSet}
        headerToolbar={{
          left: "prev",
          center: "title",
          right: "next",
        }}
      />

      <Modal isOpen={modal} toggle={toggle} className="popupmodal yes-no">
        {selectedEvent?.extendedProps.event_type == 1 ? (
          <CalendarModel
            date={date}
            setModel={setModal}
            data={selectedEvent?.extendedProps}
            apihit={apihit}
          />
        ) : (
          <>
            <button className="btn close-button" onClick={toggle}>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              />
            </button>
            <ModalBody>
              <h4>
                {selectedEvent?.extendedProps.event_type == 1
                  ? "Holiday"
                  : selectedEvent?.extendedProps.event_type == 2
                    ? "Milestone"
                    : selectedEvent?.extendedProps.event_type == 3
                      ? "Task"
                      : selectedEvent?.extendedProps.event_type == 4
                        ? "Contest"
                        : ""}
                : {selectedEvent ? selectedEvent?.title : ""}
              </h4>
              {selectedEvent?.extendedProps.event_type == 1 ? (
                <CalendarModel
                  setModel={setModal}
                  data={selectedEvent?.extendedProps}
                />
              ) : selectedEvent?.extendedProps.event_type == 2 ? (
                <ModalMilestoneDetails data={selectedEvent?.extendedProps} />
              ) : selectedEvent?.extendedProps.event_type == 3 ? (
                <ModelTaskDetails data={selectedEvent?.extendedProps} />
              ) : selectedEvent?.extendedProps.event_type == 4 ? (
                <ContestDetailModal data={selectedEvent?.extendedProps} />
              ) : (
                ""
              )}
            </ModalBody>
          </>
        )}
      </Modal>
    </div>
  );
}
